import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import PlayButton from 'components/PlayButton';

import { usePlaybackControls } from 'containers/StoryDetails/Buttons';

import {
  StoryDetailsFragment,
  useGetStoryDetailsQuery,
} from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import { usePlayer } from 'hooks/usePlayer';

import { requestPauseThunk } from 'store/modules/player';

const AudioTeaser = ({ storyId }) => {
  const dispatch = useDispatch();

  const { data: storyDetailsData } = useGetStoryDetailsQuery({
    ...useGraphaelDefaults(),
    variables: {
      storyId,
    },
  });

  const story = storyDetailsData?.story;

  const { playTeaser } = usePlaybackControls({
    story: story as StoryDetailsFragment,
    audioUrl: story?.transcodedAudioUrl || undefined,
    includeAlgoliaConversion: false,
  });

  const { isPlaying, isLoading, isMyAudio } = usePlayer();

  const handlePlay = useCallback(() => {
    if (isPlaying) {
      dispatch(requestPauseThunk());
    } else {
      playTeaser();
    }
  }, [isPlaying, playTeaser, dispatch]);

  if (!story) return null;

  return (
    <div className="AudioTeaser flex items-center gap-4 p-2 h-24 border-b border-lighter last:border-b-0">
      <div className="AudioTeaser__playButton w-10 h-10">
        <PlayButton
          isPlaying={isPlaying && isMyAudio({ id: storyId })}
          isLoading={isLoading}
          size="40"
          onClick={handlePlay}
        />
      </div>
      <h4 className="AudioTeaser__title m-0">{story.title}</h4>
    </div>
  );
};

export default AudioTeaser;
